import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const downloadExcel = async (data: any[], headers: any[], filename: string, worksheetName:string) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(worksheetName);

    // Set headers
    worksheet.columns = headers;

  

    // Populate worksheet with data
    data.forEach((item: { [x: string]: any; }) => {
        let row:any = {};
        headers.forEach((header: { key: any; }) => {
            const key:any = header.key;
             row[key] = item[key];
        });
        worksheet.addRow(row);
    });

    // Style header row
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        cell.font = { bold: true };
    });
    headerRow.height = 30;

    // Apply styling to all data rows
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        if (rowNumber > 1) {
            row.eachCell({ includeEmpty: true }, (cell) => {
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
                cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
            });
        }
    });

    // Adjust column widths
    worksheet.columns.forEach((column:any) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell:any) => {
            if (cell.value) {
                const cellValue = cell.value.toString();
                maxLength = Math.max(maxLength, cellValue.length);
            }
        });
        column.width = maxLength + 2; // Add some padding to the width
    });

    // Write to buffer and save
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `${filename}.xlsx`);
};